import { authConst, eventType } from '../../constants'
import store from '@/store'
import { hideSupportIcon, sendLogToDatadog, removeWidget, sendMessageInWidget, showCalloutBubble, endSession, openChatWidget, closeChatWidget, acceptTokenInWidget, acceptVisitorInfo, loginWidget, logoutWidget, changeLocale, backToBotAction, showExternalHeaderText, hideHeaderMenuButtons, acceptPromptTestDetails, setCalloutBubbleConfig, changeBotConfig, showVisitorInfoButton, responseAnalyzerShowVisitorInfoForm, toggleCalloutBuble } from './iframeEventHandler'

window.addEventListener("message", (event) => {
    if(event.data && eventMapperHandler[event.data.type]) {
        const eventType = event.data.type
        const eventData = event.data
        if(eventType === authConst.LOGIN_USING_OAUTH || eventType === authConst.LOGOUT_USING_OAUTH) {
           store.dispatch(eventMapperHandler[eventType], eventData)
        } else {
           eventMapperHandler[eventType](eventData)
        }
    }
}, {passive: true})

const eventMapperHandler = {
    [eventType.HIDE_SUPPORT_ICON]: hideSupportIcon,
    [eventType.SEND_LOG_TO_DATADOG]: sendLogToDatadog,
    [eventType.SEND_MESSAGE_IN_WIDGET]: sendMessageInWidget,
    [eventType.END_SESSION]: endSession,
    [eventType.OPEN_WIDGET]: openChatWidget,
    [eventType.CLOSE_WIDGET]: closeChatWidget,
    [eventType.ACCEPT_TOKEN_IN_WIDGET]: acceptTokenInWidget,
    [eventType.ACCEPT_VISITOR_INFO]: acceptVisitorInfo,
    [eventType.SHOW_CALLOUT_BUBBLE]: showCalloutBubble,
    [eventType.CHANGE_LOCALE]: changeLocale,
    [authConst.LOGIN_WIDGET]: loginWidget,
    [authConst.LOGIN_USING_OAUTH]: 'loginUsingOauth',
    [authConst.LOGOUT_USING_OAUTH]: 'logoutUsingOauth',
    [authConst.LOGOUT_WIDGET]: logoutWidget,
    [eventType.BACK_TO_BOT]: backToBotAction,
    [eventType.SHOW_EXTERNAL_HEADER_TEXT]: showExternalHeaderText,
    [eventType.HIDE_HEADER_MENU_BUTTONS]: hideHeaderMenuButtons,
    [eventType.PROMPT_TEST_DETAILS]: acceptPromptTestDetails,
    [eventType.REMOVE_WIDGET] : removeWidget,
    [eventType.SET_CALLOUT_BUBBLE_CONFIG] : setCalloutBubbleConfig,
    [eventType.SHOW_VISITOR_INFO_BUTTON]: showVisitorInfoButton,
    [eventType.RA_SHOW_VISITOR_INFO_FORM]: responseAnalyzerShowVisitorInfoForm,
    [eventType.CHANGE_BOT_CONFIG]: changeBotConfig,
    [eventType.TOGGLE_CALLOUT_BUBBLE] : toggleCalloutBuble
}
